<template>
  <PagesEconomistReportComponent
      :items="items"
      @updated="onUpdate"
  />
</template>

<script>

import _ from "underscore"
import Moment from "moment";
import {AllowStatistics} from "@/enums/permission";
import ReportService from "@/services/report.service"
import {  LAYOUT_LOADING_START,  LAYOUT_LOADING_STOP,  LAYOUT_TITLE_CHANGED} from "@/store/modules/layout/actions";
import PagesEconomistReportComponent
  from "@/components/report/CostAnalysisStatistics/PagesEconomistReportComponent.vue";
export default {
  name: "PagesCountEconomist",
  components: {
    PagesEconomistReportComponent
  },
  data() {
    return {
      items: []
    }
  },
  computed: {
    isAllowStatistics() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowStatistics
      })
    }
  },
  methods: {
    onUpdate(filters) {

      window.console.log("Hi")
      const {start, end} = filters;
      this.$store.dispatch(LAYOUT_LOADING_START)
      ReportService.getPagesEconomistReport({
        client: this.$store.getters.appActiveClient,
        start: start ? Moment(start, "YYYY-MM-DD") : null,
        end: end ? Moment(end, "YYYY-MM-DD") : null,
      })
          .then(response => {
            this.items = response.data;
            return response;
          })
          .finally(() => {
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    }
  },
  created() {
    if (this.isAllowStatistics) {
      this.$store.dispatch(LAYOUT_TITLE_CHANGED, " Статистика для економиста ")
    }
    else
      this.$router.go(-1)
  }
}
</script>

<style scoped>
</style>